import { useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";

import { GET_TOTALS } from "./queries";
import type { TPackage } from "./types";

interface IUseTotalsQuery {
  dockerImagesTotal?: number;
  packagesTotal?: number;
  rootsTotal?: number;
}

const useTotalsQuery = (groupName: string): IUseTotalsQuery => {
  const { pathname } = useLocation();
  const { data } = useQuery(GET_TOTALS, {
    fetchPolicy: "no-cache",
    skip: !pathname.includes("packages"),
    variables: { groupName },
  });

  return {
    dockerImagesTotal: data?.group.dockerImages.length,
    packagesTotal: data?.group.toePackages.total,
    rootsTotal: data?.group.gitRoots.total,
  };
};

export type { TPackage };
export { useTotalsQuery };
